import { lazy, type ComponentType, type LazyExoticComponent } from 'react';

import { recoverFromChunkLoadError } from '@/lib/chunk-load-recovery';
import { resolveLazyModuleDefault } from '@/lib/lazy-module';

const LAZY_DEFAULT_EXPORT_ERROR = 'Loading chunk failed: lazy module default export is missing';

function suspendUntilReload(): Promise<never> {
  return new Promise(() => {
    // Page reload replaces this runtime after a stale chunk is detected.
  });
}

export function lazyPage<T extends ComponentType<object>>(
  importer: () => Promise<{ default: T }>,
): LazyExoticComponent<T> {
  return lazy(async () => {
    try {
      const loadedModule = await importer();
      const normalizedModule = resolveLazyModuleDefault<T>(loadedModule);
      if (!normalizedModule) throw new Error(LAZY_DEFAULT_EXPORT_ERROR);
      return normalizedModule;
    } catch (error) {
      if (recoverFromChunkLoadError(error, 'lazy:import')) return suspendUntilReload();
      throw error;
    }
  });
}
